import { COLOR_SCHEME_DARK, COLOR_SCHEME_LIGHT } from "../THEME_BASE";
export const PRIMARY_SHADES = {
  [COLOR_SCHEME_LIGHT]: 5,
  [COLOR_SCHEME_DARK]: 5
};
